<nav 
    class="bg-white shadow-sm transition-all duration-300 min-h-[70px] md:min-h-[80px] flex items-center"
    [class.top-0]="checkMap()"
    [class.w-full]="checkMap()"
    [class.z-[1000]]="checkMap()"
    [class.shadow-lg]="checkMap()"
    id="navbar">
    <div class="container-fluid px-[30px] mx-auto px-0 w-full">
        <div class="flex items-center justify-between">
            <!-- Logo -->
            <a 
                class="flex items-center py-4 transition-opacity duration-300 hover:opacity-90" 
                routerLink="/" 
                (click)="collapseNavbar()">
                <span class="logo-img h-[48px] w-[70px] md:h-[50px] md:w-[60px] inline-block"></span>
                <span class="logo-img-text h-[40px] w-[180px] md:h-[35px] md:w-[140px] inline-block ml-2 md:ml-3"></span>
            </a>

            <!-- Mobile Toggle Button -->
            <button 
                class="md:hidden border-none p-2 rounded-md transition-colors duration-300 hover:bg-gray-100 focus:outline-none focus:ring-0"
                type="button" 
                (click)="toggleNavbar()" 
                aria-label="Toggle navigation">
                <svg class="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
            </button>

            <!-- Navigation Menu -->
            <div 
                class="md:flex md:items-center md:space-x-2"
                [class.hidden]="isNavbarCollapsed && innerWidth < 768"
                [class.flex]="!isNavbarCollapsed || innerWidth >= 768"
                [class.flex-col]="!isNavbarCollapsed && innerWidth < 768"
                [class.absolute]="!isNavbarCollapsed && innerWidth < 768"
                [class.top-full]="!isNavbarCollapsed && innerWidth < 768"
                [class.left-0]="!isNavbarCollapsed && innerWidth < 768"
                [class.right-0]="!isNavbarCollapsed && innerWidth < 768"
                [class.bg-white]="!isNavbarCollapsed && innerWidth < 768"
                [class.shadow-lg]="!isNavbarCollapsed && innerWidth < 768"
                [class.p-4]="!isNavbarCollapsed && innerWidth < 768"
                [class.w-full]="!isNavbarCollapsed && innerWidth < 768"
                [class.z-50]="!isNavbarCollapsed && innerWidth < 768"
                id="navbarResponsive">
                <ul class="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2 w-full md:w-auto">
                    <li class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            routerLink="/" 
                            routerLinkActive="active" 
                            [routerLinkActiveOptions]="{exact: true}"
                            (click)="collapseNavbar()">
                            Trang chủ
                        </a>
                    </li>
                    <li class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            routerLink="yeu-cau-tham-dinh-gia" 
                            routerLinkActive="active"
                            (click)="collapseNavbar()">
                            Yêu cầu
                        </a>
                    </li>
                    <li *ngIf="!isAuthenticated()" class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            routerLink="tra-cuu-chung-thu" 
                            routerLinkActive="active"
                            (click)="collapseNavbar()">
                            Tra cứu chứng thư
                        </a>
                    </li>
                    <li *ngIf="!isAuthenticated()" class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            routerLink="tra-cuu-nhan-vien" 
                            routerLinkActive="active"
                            (click)="collapseNavbar()">
                            Tra cứu nhân viên
                        </a>
                    </li>
                    <li *ngIf="isAuthenticated()" class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            routerLink="ho-so-phan-cong" 
                            routerLinkActive="active"
                            (click)="collapseNavbar()">
                            {{getHoSoPhanCongText()}}
                        </a>
                    </li>
                    
                    <li *ngIf="isAuthenticated() && hasThamDinhPermission()" class="w-full md:w-auto">
                        <a 
                            class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                            [class.active]="isThamDinhRoute()"
                            routerLink="list" 
                            routerLinkActive="active"
                            (click)="collapseNavbar()">
                            Thẩm định
                        </a>
                    </li>
                    <ng-container *ngIf="isAuthenticated()">
                        <li *hasAnyRole="['ROLE_NVKD']" class="w-full md:w-auto">
                            <a 
                                class="nav-link px-5 py-3 text-[15px] font-medium text-gray-800 rounded-lg transition-all duration-300 hover:text-[#104b34] hover:bg-[#faf8f5] relative flex items-center"
                                routerLink="danh-sach-user-tin-dung" 
                                routerLinkActive="active"
                                (click)="collapseNavbar()">
                                Tín Dụng
                            </a>
                        </li>
                    </ng-container>
                    <li *ngIf="!isAuthenticated()" class="md:ml-3 w-full md:w-auto">
                        <a 
                            class="px-6 py-2.5 text-sm font-semibold text-white rounded-full bg-gradient-to-br from-[#104b34] via-[#166031] to-[#7bb163] shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 text-center block"
                            (click)="login(); collapseNavbar()">
                            Đăng Nhập
                        </a>
                    </li>
                    <li *ngIf="isAuthenticated()" class="md:ml-3 w-full md:w-auto relative">
                        <jhi-user-menu-container (collapseNavbar)="collapseNavbar()"></jhi-user-menu-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>
